export const GENERIC_ERROR_MESSAGE_DESCRIPTION =
  'Please try again later or contact support for further assistance.'
